;(function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .directive('facebookPreview', facebookPreview)

  function facebookPreview () {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        thumbnail: '<',
        data: '<'
      },
      templateUrl: '/arts/directives/facebook-preview/facebook-preview-directive.html?$$REVISION$$'
    }
  }
})()
